import theme from "./theme"

//Get Base url from env
const apiBaseURL = () => process.env.REACT_APP_API_BASE_URL
//Get platform Key from env
const platformKey = () => {
  return process.env.REACT_APP_TENANT_KEY
}

const baseZameenConfig = {}

const baseBayutConfig = {}

const configs = {
  agency: "bayut",
  apiBaseURL,
  platformKey,
  odysseyApiURL: process.env.REACT_APP_ODYSSEY_BASE_URL + "/api",
  countryCode: "SA",
  countryId: 177,
  currency: "SAR",
  currencySymbolUnicode: "0xea",
  currencySymbolClass: "saudiSymbol",
  timezone: "Asia/Riyadh",
  allowBackDateForTaskCompletion: false,
  ...baseBayutConfig,
  languages: [
    {
      id: 2,
      key: "ar",
      label: "AR",
      jsFormat: "ar-SA",
      rtl: true,
      darkMode: false,
      topMenu: false,
      locale: "ar",
      fontPath: "assets/fonts/ar",
      fallbackFontInfo: "'Droid Arabic Kufi', sans-serif",
      font: "https://fonts.googleapis.com/css2?family=Droid+Arabic+Kufi:wght@400;500;700&display=swap",
      default: true,
      // momentLocale: momentAr,
    },
    {
      id: 1,
      key: "en",
      label: "EN",
      jsFormat: "en-US",
      rtl: false,
      darkMode: false,
      topMenu: false,
      locale: "en",
      font: "https://fonts.googleapis.com/css2?family=Lato:wght@400;500;700&display=swap",
      fallbackFontInfo: "'Lato', Helvetica, sans-serif",
      // momentLocale: momentEn,
    },
  ],
  locationRequired: false,
}

export { theme, configs }
